import * as RollingDatePointOptions from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDatePointOptions';
import I18n from 'I18n';
import { memo } from 'react';
import memoize from 'transmute/memoize';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import RollingDatePointConfig from '../../filterQueryFormat/rollingDates/RollingDatePointConfig';
import { TODAY } from '../../filterQueryFormat/rollingDates/RollingDatePointOptionValues';
import isString from 'transmute/isString';
import { jsx as _jsx } from "react/jsx-runtime";
const createRollingDateOptions = memoize(() => Object.values(RollingDatePointOptions).map(option => ({
  help: I18n.text(option.helpToken),
  text: I18n.text(option.textToken),
  value: option.value
})));
const FilterOperatorRollingDatePointInput = props => {
  const {
    condition,
    error,
    inputUse,
    onChange
  } = props;
  const options = createRollingDateOptions();
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const handleChange = evt => {
    const newValue = RollingDatePointConfig.fromRollingDatePointOptionValue(evt.target.value);
    onChange(syntheticEvent(condition.set('value', newValue)));
  };
  const rollingDateOptionValue = isString(condition.value) || typeof condition.value === 'undefined' ? TODAY : RollingDatePointConfig.toRollingDatePointOptionValue(condition.value);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: isError,
      validationMessage: errorMessage,
      children: /*#__PURE__*/_jsx(UISelect, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
        onChange: handleChange,
        options: options,
        value: rollingDateOptionValue
      })
    })
  });
};
export default /*#__PURE__*/memo(FilterOperatorRollingDatePointInput);